//https://angular.io/guide/dynamic-component-loader
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[quizQuestionPartChoicesResultHost]',
    standalone: true
})
export class QuizQuestionPartChoicesResultDirective {
   constructor(public viewContainerRef: ViewContainerRef) {
      //console.log('constructor:QuizQuestionPartChoice directive');
   }
}
